import { Popover, PopoverTrigger } from '@fluentui/react-components';
import { StyledPopOverSurface } from './ApprovalStatusField.styled';
import { ApprovalFieldProps } from './ApprovalStatusField.types';
import { ticketApprovalStatusLookUp } from 'src/components/Tickets/MyTickets.constants';

const PopOverHover = ({ approval }: ApprovalFieldProps) => {
  const approvalLabel = approval && ticketApprovalStatusLookUp[approval]?.label;
  const IconComponent = approval && ticketApprovalStatusLookUp[approval]?.icon;

  return (
    <Popover
      unstable_disableAutoFocus={false}
      openOnHover
      positioning="below-start"
      mouseLeaveDelay={0}
    >
      <PopoverTrigger>
        <IconComponent />
      </PopoverTrigger>
      <StyledPopOverSurface>{approvalLabel}</StyledPopOverSurface>
    </Popover>
  );
};

export const ApprovalStatusField = ({
  approval,
  hoverPopover,
}: ApprovalFieldProps) => {
  const IconComponent = approval && ticketApprovalStatusLookUp[approval]?.icon;
  if (!approval) return null;

  return hoverPopover ? (
    <PopOverHover approval={approval} />
  ) : (
    <IconComponent />
  );
};
